import { Role, TENANT, TENANTS } from "../../config/constant";

export const CbiRoleOptions = TENANT === TENANTS.FAV ? [
    { value: Role.AM, label: 'AM' },
    { value:  Role.MM, label: 'MM' },
] : [
    { value: Role.AM, label: 'AM' },
    { value:  Role.BM, label: 'BM' },
]